var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59922 4.2002C2.27374 4.2002 1.19922 5.27471 1.19922 6.60019V17.4002C1.19922 18.7257 2.27374 19.8002 3.59922 19.8002H20.3992C21.7247 19.8002 22.7992 18.7257 22.7992 17.4002V6.6002C22.7992 5.27471 21.7247 4.2002 20.3992 4.2002H3.59922ZM11.2552 8.47214L15.0952 11.3521C15.5194 11.6703 15.6053 12.272 15.2872 12.6961L15.2294 12.7661C15.1886 12.8109 15.1437 12.8518 15.0952 12.8881L11.2552 15.7681C10.8311 16.0863 10.2293 16.0003 9.91122 15.5761C9.78659 15.41 9.71922 15.2079 9.71922 15.0001V9.24014C9.71922 8.70995 10.149 8.28014 10.6792 8.28014C10.8869 8.28014 11.089 8.34751 11.2552 8.47214Z",
    fill: "#001B53",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/videoPlayer.7302b2d46d5ed2475017e0cdc09c5c5c.svg";
export { ForwardRef as ReactComponent };